<template>
<span class="material-symbols-outlined" @click="saveBlock()">database</span>
<span class="material-symbols-outlined" @click="sendBlockInfoToStore('reference')">lightbulb</span>
<span class="material-symbols-outlined" @click="sendBlockInfoToStore('copy')">content_copy</span>
</template>

<script>
import { mapActions } from 'vuex';
import { saveBlockToDb } from '@/utils/db/saveBlock';

export default {
    name: 'CopyBlock',
    props: ['sharedData'],
    methods:{
        ...mapActions(['updateCopyClipboard']),
        sendBlockInfoToStore(copyType){
            //const copiedBlock = JSON.parse(JSON.stringify(this.sharedData));
            this.updateCopyClipboard({copyType, ...this.sharedData});
            console.log({copyType, ...this.sharedData})
        },
        async saveBlock(){
            const data = this.sharedData.data
            const type = this.sharedData.type
            const dataObject = {data, type}
            console.log(dataObject)
            try {
                await saveBlockToDb(dataObject); // Warten auf Abschluss der Speicherung
                console.log("E-Mail erfolgreich gespeichert!");
                } catch (error) {
                console.error("Fehler beim Speichern der E-Mail:", error);
                }
                console.log(this.sharedData)
                }
            }
            }
</script>

<style scoped>
span {
    cursor: pointer;
    color: #cccc;
}

span:hover {
    color: black;
}
</style>